import { useState, useEffect } from 'react';

export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  });

  const [breakpoint, setBreakpoint] = useState('lg');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setScreenSize({ width, height });
      
      // Tailwind CSS breakpoints
      if (width < 640) {
        setBreakpoint('xs');
      } else if (width < 768) {
        setBreakpoint('sm');
      } else if (width < 1024) {
        setBreakpoint('md');
      } else if (width < 1280) {
        setBreakpoint('lg');
      } else {
        setBreakpoint('xl');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call once to set initial values

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isXs = breakpoint === 'xs';
  const isSm = breakpoint === 'sm' || isXs;
  const isMd = breakpoint === 'md' || isSm;
  const isLg = breakpoint === 'lg' || isMd;
  const isXl = breakpoint === 'xl' || isLg;

  const isMobile = isXs || breakpoint === 'sm';
  const isTablet = breakpoint === 'md';
  const isDesktop = breakpoint === 'lg' || breakpoint === 'xl';

  return {
    screenSize,
    breakpoint,
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    isMobile,
    isTablet,
    isDesktop,
  };
};

export default useResponsive;